import SimpleMarkdown from 'components/SimpleMarkdown';
import { Box, Tab, Tabs } from 'grommet';
import usePageTitle from 'hooks/usePageTitle';
import React from 'react';
import { connect } from 'rxbeach/react';
import { Course } from 'types';
import CourseCard from './CourseCard';
import Courses from './Courses';
import { courseViewModel$ } from './course$';
import styled from 'styled-components';

const MyTabs = styled(Tabs)`
  & > div:first-child {
    flex-wrap: wrap;
    overflow-x: auto;
  }
`

const CourseHome = ({ visibleCourses, byTab }: { byTab: any, visibleCourses: Course[] }) => {
  usePageTitle('Kurs');
  return (
  <Box align="center" justify="center" pad="large">
    <MyTabs>
      <Tab title="Alle kurs">
        <Box pad="medium">
          <Courses />
        </Box>
      </Tab>
      {Object.entries(byTab).map(([tab, items]) => (
        <Tab title={tab} key={tab}>
          {(items as any[]).map((asset, i) => (
            <SimpleMarkdown key={asset.id} asset={asset} />
          ))}
          <Box
            direction="row"
            align="center"
            justify="center"
            gap="medium"
            pad="medium"
            wrap>
            {visibleCourses.filter(e => e.type === tab).map((course) => (
              <CourseCard
                key={course.id}
                {...course}
              />
            ))}
          </Box>
        </Tab>
      ))}
    </MyTabs>
  </Box>
  );
};


export default connect(CourseHome, courseViewModel$);
